import React from 'react';
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import EmployeeComponent from './Employee';
import { Schema } from '../../../../../amplify/data/resource';
import { SelectionSet } from 'aws-amplify/api';

const employeeSelectionSet = [
  'id',
  'firstName',
  'lastName',
  'employeeId',
  'salaryMonth',
  'depositId'
] as const;

const fundContributionSelectionSet = [
  'id',
  'contributionType',
  'contributionAmount',
  'contributionRate',
  'exemptPayments',
  'registryIdentifier',
  'previousRegistryIdentifier',
  'status',
  'error',
  'employeeId',
  'salaryMonth',
] as const;

const depositSelectionSet = [
  'id',
  'totalDepositAmount',
  'fundIdentifier',
  'fundNameAtEmployer',
] as const;

// @ts-ignore
type Employee = SelectionSet<Schema['Employee']['type'], typeof employeeSelectionSet>;

// @ts-ignore
type FundContribution = SelectionSet<Schema['FundContribution']['type'], typeof fundContributionSelectionSet>;

// @ts-ignore
type Deposit = SelectionSet<Schema['Deposit']['type'], typeof depositSelectionSet>;

interface EmployeesListProps {
  employees: Employee[];
  fundContributions: FundContribution[];
  deposits: Deposit[];
}

const EmployeesList: React.FC<EmployeesListProps> = ({ employees, fundContributions, deposits }) => {
  return (
    <Box sx={{ direction: 'rtl', width: '100%' }}>
      <TableContainer
        component={Paper}
        sx={{
          backgroundColor: 'transparent',
          boxShadow: 'none',
          overflowY: 'auto',
          width: '100%',
        }}
      >
        <Table
          stickyHeader
          sx={{
            backgroundColor: 'transparent',
            borderCollapse: 'separate',
            borderSpacing: '0 10px',
            width: '100%',
            tableLayout: 'fixed',
          }}
        >
          <TableHead>
            <TableRow sx={{ backgroundColor: '#E7ECF1' }}>
              <TableCell
                sx={{
                  padding: '10px 20px',
                  borderBottom: 'none',
                  textAlign: 'right',
                  backgroundColor: '#E7ECF1',
                  width: '12%',
                }}
              >
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  שם מלא עובד
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  padding: '10px 20px',
                  borderBottom: 'none',
                  textAlign: 'right',
                  backgroundColor: '#E7ECF1',
                  width: '11%',
                }}
              >
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  שם יצרן
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  padding: '10px 20px',
                  borderBottom: 'none',
                  textAlign: 'right',
                  backgroundColor: '#E7ECF1',
                  width: '11%',
                }}
              >
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  ח.פ. יצרן
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  padding: '10px 20px',
                  borderBottom: 'none',
                  textAlign: 'right',
                  backgroundColor: '#E7ECF1',
                  width: '11%',
                }}
              >
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  שם קופה
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  padding: '10px 20px',
                  borderBottom: 'none',
                  textAlign: 'right',
                  backgroundColor: '#E7ECF1',
                  width: '11%',
                }}
              >
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  מספר קופה
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  padding: '10px 20px',
                  borderBottom: 'none',
                  textAlign: 'right',
                  backgroundColor: '#E7ECF1',
                  width: '11%',
                }}
              >
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  חודש שכר
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  padding: '10px 20px',
                  borderBottom: 'none',
                  textAlign: 'right',
                  backgroundColor: '#E7ECF1',
                  width: '11%',
                }}
              >
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  סך פרמיה
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  padding: '10px 20px',
                  borderBottom: 'none',
                  textAlign: 'right',
                  backgroundColor: '#E7ECF1',
                  width: '11%',
                }}
              >
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  סטטוס רשומה
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  padding: '10px 20px',
                  borderBottom: 'none',
                  textAlign: 'right',
                  backgroundColor: '#E7ECF1',
                  width: '11%',
                }}
              >
                <Typography
                  fontSize="14px"
                  fontWeight="700"
                  fontFamily={'AlmoniDL'}
                >
                  פרטי סוכן
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  padding: '10px 20px',
                  borderBottom: 'none',
                  textAlign: 'right',
                  backgroundColor: '#E7ECF1',
                  width: '10%',
                }}
              >
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {employees.map((employee: Employee, index: number) => (
               <EmployeeComponent key={employee.id || index} employee={employee} fundContributions={fundContributions} deposits={deposits} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default EmployeesList;
